/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { DeleteOrgMemberOptions, DeleteOrgMemberResponses } from '../../models/DeleteOrgMember'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Delete Org Member
 * {@link /org/member/:user_id}
 */
export function deleteOrgMember<ThrowOnError extends boolean = true>(options: Options<DeleteOrgMemberOptions, ThrowOnError>): Promise<UnwrappedResult<DeleteOrgMemberResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'DELETE', url: '/org/member/{user_id}', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<DeleteOrgMemberResponses, ThrowOnError>>
}
